import * as api from '../../services/checkin'
import lodash from 'lodash'
export const FETCH_CHECKINLOGS = 'FETCH_CHECKINLOGS';
export const FETCH_GPBYATTDS= 'FETCH_GPBYATTDS';


export const fetchGpbyattds = (values) => {
    return {
        type: FETCH_GPBYATTDS,
        payload: {
            promise: api.findGpbyattds(values)
        }
    }
}

export const fetchCheckinlogs= (params, pagination, sort, extra) => {
    return {
        type: FETCH_CHECKINLOGS,
        payload: {
            promise: api.findCheckinlogs(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params,'uniqueField'),
            sort: sort,
            extra: extra
        }
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/checkin.js